import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { CartProduct, Product } from '../classes/orders';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';

@Injectable({
	providedIn: 'root'
})

export class PurchasingService {


	key = 'UET6DFMPAXW7BKCB';
	items: Product[] = [];
	config: any;
	user: any = [];
	package: any = '';

	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {

		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})
	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	public getOrderInqSearch(params: {
		keywords: string;
		vendors?: string[];
		limit?: number;
	}) {
		const method = 'purchasing/inqsearch';
		const payload: {
			keywords: string;
			supplierid?: string;
			limit?: number;
		} = {
			keywords: params.keywords != null ? String(params.keywords) : '',
		};
		if (params.vendors && params.vendors.length) {
			payload.supplierid = params.vendors.filter((v) => v != null && String(v).trim() !== '').join(',');
		}
		if (params.limit != null && params.limit > 0) {
			payload.limit = params.limit;
		}
		return this.http.post(this.setEndPoint(method), payload, this.httpOptions).pipe(
			catchError(this.handleError(method, payload))
		);
	}

	public getMstPo(data: any) {
		const method = 'purchasing/getmstpo';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getPurchasesForItemByVendor(data: any) {
		const method = 'purchasing/vendoritempending';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public mailDiscrepancy(data: any) {
		const method = 'purchasing/maildiscrepancy';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public finalizeRec(data: any) {
		const method = 'oms/recitems/putrecitems';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public removeRec(data: any) {
		const method = 'oms/recitems/removerecitems';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getRecs(data: any) {
		const method = 'oms/recitems/getrecs';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public updateRec(data: any) {
		const method = 'oms/recitems/updaterecitems';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getRgasForItemByVendor(data: any) {
		const method = 'purchasing/rgavendoritempending';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	// public getRecScanHistory() {
	// 	var method = 'oms/recitems/getrecs';
	// 	return this.http.get(this.setEndPoint(method));
	// }

	public removeScannned(data: any) {
		const method = 'oms/recitems/removescannneditem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public decrementScannned(data: any) {
		const method = 'oms/recitems/decrementscannneditem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public incrementScannned(data: any) {
		const method = 'oms/recitems/incrementscannneditem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public updateScanned(data: any) {
		const method = 'oms/recitems/updatescanneditem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getTruckIncoming(data: any) {
		const method = 'purchasing/truckincoming';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}
	public setTruckHold(data: any) {
		const method = 'purchasing/holdreceiving';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}
	public setTruckDone(data: any) {
		const method = 'purchasing/finalreceiving';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}
	public discontinueItems(data: any) {
		const method = 'purchasing/discontinueitems';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public updateItem(data: any) {
		const method = 'purchasing/updateitemminmax';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getBackOrders(data: any) {
		const method = 'inventory/backorder';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}
	public getFilters() {
		const method = 'filters/purchasing';
		return this.http.get(this.setEndPoint(method));
	};

	public getFiltersTwo() {
		const method = 'filters/purchasingtwo';
		return this.http.get(this.setEndPoint(method));
	};

	public buildPoFromUpload(data) {
		const method = 'purchasing/buildpo';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}



	public removePurchaseDate(data: any) {
		const method = 'purchasing/purchdata/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public printPreviewPo(data: any) {
		const method = 'purchasing/order/preview';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public addPurchaseDate(data: any) {

		const method = 'purchasing/purchdata/add';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);

	}

	public getRemoteQty(stockids: any) {
		const method = 'remote/inventory/get';
		return this.http.post(this.setEndPoint(method), stockids, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public loadPurchaseOrder(order: any) {
		const method = 'purchasing/order/loadorder&orderno=' + order;
		return this.http.get(this.setEndPoint(method));

	}

	public loadRga(order: any) {
		const method = 'rga/order/loadorder&orderno=' + order;
		return this.http.get(this.setEndPoint(method));

	}

	public getPurchaseOrder(order: any) {
		const method = 'purchasing/order/getorder&orderno=' + order;
		return this.http.get(this.setEndPoint(method));

	}

	public getRga(order: any) {
		const method = 'rga/order/getorder&orderno=' + order;
		return this.http.get(this.setEndPoint(method));

	}

	public geMinMaxRecomendationsTwo(data: any) {
		const method = 'purchasing/reorder/minmaxtwo';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}

	public geMinMaxRecomendations(data: any) {
		const method = 'purchasing/reorder/minmax';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}

	public getStockRecomendations(data: any) {
		const method = 'purchasing/reorder/recomendations';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}
	public getStockRecomendationsAvg(data: any) {
		const method = 'purchasing/reorder/breord';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}

	public getMixesRecomendations(data: any) {
		const method = 'purchasing/reorder/mixed';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}

	public getDailyRecomendations(data: any) {
		const method = 'purchasing/reorder/daily';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}


	public getReStock(data: any) {
		const method = 'purchasing/reorder/restock';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}

	public closeJournal(journal: any) {
		const method = 'purchasing/closejounral';
		return this.http.post(this.setEndPoint(method), journal, this.httpOptions).pipe(
			catchError(this.handleError(method, journal))
		);
	}

	public getOpenByItem(stockid: any) {

		const method = 'oms/put/getopenitem&stockid=' + stockid;
		return this.http.get(this.setEndPoint(method));
	}

	public getItemScan(data: any) {
		const method = 'purchasing/items/scan';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}

	public getItemSearch(data: any) {
		const method = 'purchasing/items/search';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}

	public getPutAwaySearch(data: any) {
		const method = 'oms/put/search';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
		return this.http.get(this.setEndPoint(method));
	}



	public getOpenGrns() {
		const method = 'purchasing/order/grns';
		return this.http.get(this.setEndPoint(method));
	}

	public getOpenGrnBatches(supplierid: any) {
		const method = 'purchasing/order/opengrns&supplierid=' + supplierid;
		return this.http.get(this.setEndPoint(method));
	}

	public getGrnDetails(supplierid: any) {
		const method = 'purchasing/order/grns&supplierid=' + supplierid;
		return this.http.get(this.setEndPoint(method));
	}

	public getRmaOpenGrnBatches(supplierid: any) {
		const method = 'vendor/credit/opengrns&supplierid=' + supplierid;
		return this.http.get(this.setEndPoint(method));
	}

	public getRmaGrnDetails(supplierid: any) {
		const method = 'vendor/credit/grns&supplierid=' + supplierid;
		return this.http.get(this.setEndPoint(method));
	}

	public getStockMovementsWithoutPO(supplierid: string, limit = 1000, filters?: { dateFrom?: string; dateTo?: string }) {
		const method = 'purchasing/order/stockmovementswithoutpo';
		const body: { supplierid: string; limit: number; dateFrom?: string; dateTo?: string } = { supplierid, limit };
		if (filters?.dateFrom) body.dateFrom = filters.dateFrom;
		if (filters?.dateTo) body.dateTo = filters.dateTo;
		return this.http.post(this.setEndPoint(method), body, this.httpOptions);
	}

	public linkStockMovementToPO(data: any) {
		const method = 'purchasing/order/linkstockmovementtopo';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions);
	}

	public linkStockMovementsToPOBatch(data: {
		supplierid: string;
		salesOrderRef?: string;
		groups: Array<{
			groupId: string | null;
			poNumber?: string;
			items: Array<{
				stkmoveno: number;
				unitprice: number;
			}>;
		}>;
	}) {
		const method = 'purchasing/order/linkstockmovementstopobatch';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions);
	}
	public getStockMovementsWithoutRGA(supplierid: string, limit: number = 1000, filters?: { dateFrom?: string; dateTo?: string }) {
		const method = 'rga/order/stockmovementswithoutrga';
		const body: { supplierid: string; limit: number; dateFrom?: string; dateTo?: string } = { supplierid, limit };
		if (filters?.dateFrom) body.dateFrom = filters.dateFrom;
		if (filters?.dateTo) body.dateTo = filters.dateTo;
		return this.http.post(this.setEndPoint(method), body, this.httpOptions);
	}
    public linkStockMovementsToRGABatch(data: {
		supplierid: string;
		salesOrderRef?: string;
		groups: Array<{
			groupId: string | null;
			rgaNumber?: string;
			items: Array<{
				stkmoveno: number;
				unitprice: number;
			}>;
		}>;
	}) {
		const method = 'rga/order/linkstockmovementstorgabatch';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions);
	}
	public getPurchaseOrderDetails(orderno: any) {
		const method = 'purchasing/order/details&orderno=' + orderno;
		return this.http.get(this.setEndPoint(method));
	}

	public searchPurchaseOrders(search: any) {
		//var method = 'purchasing/order';
		const method = 'purchasing/order';
		return this.http.post(this.setEndPoint(method), search, this.httpOptions).pipe(
			catchError(this.handleError(method, search))
		);
	}

	public searchRgas(search: any) {
		//var method = 'purchasing/order';
		const method = 'rga/order';
		return this.http.post(this.setEndPoint(method), search, this.httpOptions).pipe(
			catchError(this.handleError(method, search))
		);
	}

	public getDealerCodes() {
		const method = 'purchasing/dealercodes';
		return this.http.get(this.setEndPoint(method));
	}

	public getPurchaseOrders() {
		const method = 'purchasing/order';
		return this.http.get(this.setEndPoint(method));
	}

	public getRgas() {
		const method = 'purchasing/order';
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorPurchaseOrders(vendorid: any, status?: string) {
		let method = 'purchasing/order&supplierid=' + vendorid;
		if (status) {
			method += '&status=' + status;
		}
		return this.http.get(this.setEndPoint(method));
	}

	public completeVendorPurchaseOrder(data: any) {
		const method = 'purchasing/order/receive';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public completeRgaShipping(data: any) {
		const method = 'rga/ship';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getStatus() {
		const method = 'purchasing/order/statuses';
		return this.http.get(this.setEndPoint(method));
	}

	public getLocations(loccode: any) {
		const method = 'purchasing/getlocations&loccode=' + loccode;
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Supplier list or single vendor. POST body supports inc_disabled to include inactive vendors (active=0).
	 */
	public getSuppliers(supplierid: string = '', options?: { inc_disabled?: boolean }) {
		const method = 'purchasing/getsuppliers';
		const body = {
			supplierid: supplierid != null ? String(supplierid) : '',
			inc_disabled: options?.inc_disabled === true,
		};
		return this.http.post(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	public getSupplier(supplier: any) {
		const method = 'purchasing/getsupplier&supplierid=' + supplier;
		return this.http.get(this.setEndPoint(method));
	}


	public getCustomer(customerid) {
		const method = 'customers/getcustomer&customerid=' + customerid;
		return this.http.get(this.setEndPoint(method));
	}

	public getOrders() {
		const method = 'purchasing/order';
		return this.http.get(this.setEndPoint(method));
	}

	public getDispatches() {
		const method = 'orders/dispatches';
		return this.http.get(this.setEndPoint(method));
	}

	public getProducts(search) {
		const method = 'purchasing/items/supplieritems';
		return this.http.post(this.setEndPoint(method), search, this.httpOptions).pipe(
			catchError(this.handleError(method, search))
		);
	}

	public getOrder(oid) {
		const method = 'orders/getdetails&oid=' + oid;
		return this.http.get(this.setEndPoint(method));
	}

	public setOrderItems(items) {
		this.items = items;
	}

	public addToOrder(product: any, supplier: any) {
		this.items.push(product);
		const method = 'purchasing/add';
		return this.http.post(this.setEndPoint(method), { item: product, supplier: supplier }, this.httpOptions).pipe(
			catchError(this.handleError(method, product))
		);
	}

	public addToCredit(product: any, supplier: any) {
		this.items.push(product);
		const method = 'rga/add';
		return this.http.post(this.setEndPoint(method), { item: product, supplier: supplier }, this.httpOptions).pipe(
			catchError(this.handleError(method, product))
		);
	}

	public addMultipleToOrder(products: any, supplierid: string) {
		const method = 'purchasing/addmultiple';
		return this.http.post(this.setEndPoint(method), { items: products, supplierid: supplierid }, this.httpOptions).pipe(
			catchError(this.handleError(method, products))
		);
	}

	public addMultipleToRga(products: any, supplierid: string) {
		const method = 'rga/addmultiple';
		return this.http.post(this.setEndPoint(method), { items: products, supplierid: supplierid }, this.httpOptions).pipe(
			catchError(this.handleError(method, products))
		);
	}

	public getQOP(products: any) {
		const method = 'purchasing/order/getqop';
		return this.http.post(this.setEndPoint(method), { items: products }, this.httpOptions).pipe(
			catchError(this.handleError(method, products))
		);
	}


	public uploadFile(formdata: any) {
		const method = 'purchasing/filedrop';
		return this.http.post(this.setEndPoint(method), formdata, this.httpOptions).pipe(
			catchError(this.handleError(method, formdata))
		);
	}

	public updateStatus(data: any) {
		const method = 'purchasing/order/updatestatus';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public updateRgaStatus(data: any) {
		const method = 'rga/order/updatestatus';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public updateOrder(product) {
		const method = 'purchasing/update';
		return this.http.post(this.setEndPoint(method), product, this.httpOptions).pipe(
			catchError(this.handleError(method, product))
		);
	}

	public updateCredit(product) {
		const method = 'rga/update';
		return this.http.post(this.setEndPoint(method), product, this.httpOptions).pipe(
			catchError(this.handleError(method, product))
		);
	}



	public updatePurchaseOrder(data: any) {
		const method = 'purchasing/order/updatepurchaseorder';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public createPurchaseOrdersFromRecomend(data: any) {
		const method = 'purchasing/order/createfromrecommendations';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, method))
		);
	}

	public createPurchaseOrders(data: any) {
		const method = 'purchasing/order/createfromsalesorder';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, method))
		);
	}

	public createPurchaseOrder(supplier: any, header: any, details: any, user: any, remoteorder: any = false, dealercode: any = false) {
		const method = 'purchasing/order/create';
		return this.http.post(this.setEndPoint(method), {
			supplier: supplier,
			header: header,
			details: details,
			user: user,
			remoteorder: remoteorder,
			dealercode: dealercode
		}, this.httpOptions).pipe(
			catchError(this.handleError(method, method))
		);
	}

	public createRga(supplier: any, header: any, details: any, user: any, rga_type?: string) {
		const method = 'rga/order/create';
		return this.http.post(this.setEndPoint(method), { supplier: supplier, header: header, details: details, user: user }, this.httpOptions).pipe(
			catchError(this.handleError(method, method))
		);
	}


	public clearCart(supplierno) {
		this.items = [];
		const method = 'purchasing/clearcart';
		return this.http.post(this.setEndPoint(method), { customerno: supplierno }, this.httpOptions).pipe(
			catchError(this.handleError(method, supplierno))
		);
	}

	public clearOrder(supplierno) {
		this.items = [];
		const method = 'purchasing/clear';
		return this.http.post(this.setEndPoint(method), { customerno: supplierno }, this.httpOptions).pipe(
			catchError(this.handleError(method, supplierno))
		);
	}

	public clearCredit(supplierno) {
		this.items = [];
		const method = 'rga/clear';
		return this.http.post(this.setEndPoint(method), { customerno: supplierno }, this.httpOptions).pipe(
			catchError(this.handleError(method, supplierno))
		);
	}

	public removeFromCredit(cart_id, customer) {

		const method = 'rga/remove';
		return this.http.post(this.setEndPoint(method), { cart_id: cart_id, customer: customer }, this.httpOptions).pipe(
			catchError(this.handleError(method, cart_id))
		);
	}

	public cancelCredit(data: any) {
		const method = 'rga/cancelorder';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getRgaCancelReasons() {
		const method = 'cancelreasons/rga';
		return this.http.get(this.setEndPoint(method), this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public removeFromOrder(cart_id, customer) {

		const method = 'purchasing/remove';
		return this.http.post(this.setEndPoint(method), { cart_id: cart_id, customer: customer }, this.httpOptions).pipe(
			catchError(this.handleError(method, cart_id))
		);
	}

	public cancelOrder(data: any) {
		const method = 'purchasing/cancelorder';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getOrderItems(supplier: any) {
		const method = 'purchasing/getorder&supplier=' + supplier;
		this.getCart(supplier).subscribe((results: Product[]) => {
			this.items = results;
			return results
		});;

		return this.items;
	}

	public getCart(supplier) {
		const method = 'purchasing&supplierid=' + supplier;
		return this.http.get(this.setEndPoint(method));
	}

	public getRgaCart(supplier) {
		const method = 'rga&supplierid=' + supplier;
		return this.http.get(this.setEndPoint(method));
	}

	public getOrderList(oid) {
		const method = 'orders/getdetails&oid=' + oid;
		return this.http.get(this.setEndPoint(method));
	}

	public getPicking() {
		const method = 'oms/fillable';
		return this.http.get(this.setEndPoint(method));
	}

	public setPicking(data) {
		const method = 'orders/pick';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public updatePo(product: any, supplier: any) {
		const method = 'purchasing/update';
		return this.http.post(this.setEndPoint(method), { item: product, supplier: supplier }, this.httpOptions).pipe(
			catchError(this.handleError(method, product))
		);
	}

	public getTotals(supplier: any, freight: any = 0) {
		const method = 'purchasing/gettotals&supplierid=' + supplier;
		return this.http.post(this.setEndPoint(method), supplier, this.httpOptions).pipe(
			catchError(this.handleError(method, supplier))
		);
	}

	public getRgaTotals(supplier: any, freight: any = 0) {
		const method = 'rga/gettotals&supplierid=' + supplier;
		return this.http.post(this.setEndPoint(method), supplier, this.httpOptions).pipe(
			catchError(this.handleError(method, supplier))
		);
	}

	public updateRgaItem(data: any) {
		const method = 'apir/rga/updateitem';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public emailPO(data) {
		const method = 'purchasing/emailpo';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if (p) {
			return '&package=' + p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError < T > (operation = 'operation', result ? : T) {

		return (error: any): Observable < T > => {

			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/logout';
			}

			return throwError(() => error);
		};
	}

}